import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import Card from "../../../components/card";
import {FaHistory, FaQuestionCircle} from "react-icons/fa";
import InputForm from "../../../components/input-form";
import SelectComponent from "../../../components/select-component";
import InputText from "../../../components/input-text";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import EquipmentTable from "./equipment-table";
import ContactsTable from "./contacts-table";
import SshTable from "./ssh-table";
import {MaskDefault} from "../../../utils/mask";
import InputCheckbox from "../../../components/input-checkbox";
import Button from "../../../components/button";
import {ProjectContext} from "../../../context/project-context";
import LicenseHistoryModal from "../../licenses/components/license-history-modal";
import InputDateTime from "../../../components/input-datetime";
import moment from "moment";

const ResumeCard = ({state, resales, resumeLinkRef, resumeObservationRef, setMultiwayLinkHeight, setInstObsHeight, options, commercialOpt}) => {
    const {user} = useContext(ProjectContext);
    const licencesRef = useRef();
    const contactsRef = useRef();
    const sshRef = useRef();
    const equipmentRef = useRef();
    const [licenseHistoryOpen, setLicenseHistoryOpen] = useState(false);

    const hasLicensesHistoryPermission = user?.permissions?.includes("licenses_history");

    const [pinnedBottomValues, setPinnedBottomValues] = useState({ date_start: "Total", cameras: 0, users: 0, ocr: 0, contactid: 0, mobile: 0 });

    useEffect(() => licensesTotals(state), [state]);

    const licensesTotals = (state) => {
        let rowData = state.project_licensing
        const totals = rowData.reduce(
            (acc, row) => {
                acc.cameras += row.cameras || 0;
                acc.users += row.users || 0;
                acc.ocr += row.ocr || 0;
                acc.contactid += row.contactid || 0;
                acc.mobile += row.mobile || 0;
                return acc;
            },
            { cameras: 0, users: 0, ocr: 0, contactid: 0, mobile: 0 }
        );

        setPinnedBottomValues({ date_start: "Total", ...totals });
    };

    const [licensesColumnDefs] = useState( () => [
        {field: "date_start", headerName: "Inclusão", flex: 1},
        {field: "cameras", headerName: "Câmeras", flex: 1},
        {field: "users", headerName: "Usuários", flex: 1},
        {field: "ocr", headerName: "OCR", flex: 1},
        {field: "contactid", headerName: "Patrimonial", flex: 1},
        {field: "mobile", headerName: "Mobile", flex: 1}
    ]);

    const defaultColDef = useMemo(() => ({editable: false, suppressMenu: true, cellStyle: { cursor: 'default' }}), []);

    const readOnlyTable = true

    useEffect(() => {
        if (resumeLinkRef.current && state.multiway_link !== "" && resumeLinkRef.current.scrollHeight > 138) {
            resumeLinkRef.current.style.height = 'auto';
            resumeLinkRef.current.style.height = (resumeLinkRef.current.scrollHeight + 10) + 'px';
            setMultiwayLinkHeight(resumeLinkRef.current.style.height)
        }
        if (resumeObservationRef.current && state.install_observation !== "" && resumeObservationRef.current.scrollHeight > 138) {
            resumeObservationRef.current.style.height = 'auto';
            resumeObservationRef.current.style.height = (resumeObservationRef.current.scrollHeight + 10) + 'px';
            setInstObsHeight(resumeObservationRef.current.style.height)
        }
    }, [resumeLinkRef, resumeObservationRef, setInstObsHeight, setMultiwayLinkHeight, state.install_observation, state.multiway_link]);

    return (
        <Card title="Resumo">
            <span style={{ whiteSpace: 'nowrap', marginRight: '1rem'}} className="text-lg">Dados</span>
            <div style={{ flex: 1, borderBottom: '1px solid #ccc' }}></div>
            <div className="flex items-center justify-end">
                <input type="checkbox" id="dead_file" checked={state.dead_file} readOnly={true}
                       className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded custom-checkbox-color"/>
                <label htmlFor="dead_file"
                       className="flex items-center gap-2 ml-2 text-gray-700 text-lg cursor-pointer select-none"
                       title="Essa flag deve ser usada quando o Sentry for desativado ou removido">
                    Arquivo morto <FaQuestionCircle/>
                </label>
            </div>

            <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12 mt-4">

                <div className={"text-gray-900 col-span-5"}>
                    <InputForm id="name" name="name" value={state.name} disabled={true} label="Nome *"
                               />
                </div>

                <InputDateTime
                    id="activation_date"
                    selected={state.activation_date ? moment(state.activation_date).toDate() : null}
                    disabled={true}
                    label="Data de ativação"
                    col="col-span-2"
                />

                <InputDateTime
                    id="expiration_date"
                    selected={state.expiration_date ? moment(state.expiration_date).toDate() : null}
                    disabled={true}
                    label="Data de expiração"
                    col="col-span-2"
                />

                <InputDateTime
                    id="answer"
                    selected={state.answer ? moment(state.answer).toDate() : null}
                    disabled={true}
                    label="Podemos atender até"
                    col="col-span-2"
                />

                <div className="col-span-5 text-gray-900">
                    <SelectComponent
                        isDisabled={true}
                        instanceId="commercial_contact_id"
                        label="Contato comercial"
                        options={commercialOpt}
                        value={state.commercial_contact_id}
                    />
                </div>

                <div className="col-span-5 text-gray-900">
                    <SelectComponent
                        isDisabled={true}
                        instanceId="resales"
                        options={resales ?? []}
                        label="Revendas relacionadas"
                        value={state.resales}
                    />
                </div>

                <InputForm id="phone" name="phone" value={state.phone} disabled={true}
                           mask={MaskDefault.phone} label="Telefone" col="col-span-2" whatsApp={true}/>

                <div className="col-span-3 text-gray-900">
                    <SelectComponent
                        isDisabled={true}
                        instanceId="type_license"
                        label="Tipo da licença"
                        options={[
                            {value: "ADVANCED", label: "ADVANCED"},
                            {value: "BASIC", label: "BASIC"},
                            {value: "ENHANCED", label: "ENHANCED"},
                            {value: "ENTERPRISE", label: "ENTERPRISE"},
                            {value: "STARTER", label: "STARTER"},
                        ]}
                        value={state.type_license}
                        name="type_license"
                    />
                </div>

                <div className="col-span-2 text-gray-900">
                    <SelectComponent
                        isDisabled={true}
                        instanceId="modality"
                        label="Modalidade"
                        options={[
                            {value: "LOCATION", label: "LOCAÇÃO"},
                            {value: "ACQUISITION", label: "AQUISIÇÃO"},
                            {value: "DEMONSTRATION", label: "DEMONSTRAÇÃO"},
                            {value: "DEVELOPMENT", label: "DESENVOLVIMENTO"},
                            {value: "RELATED", label: "RELACIONADA"}
                        ]}
                        value={state.modality}
                        name="modality"
                    />
                </div>

                {
                    (state.modality?.value === "RELATED" || state.modality === "RELATED") &&
                    <>
                        <div className="col-span-3 text-gray-900">
                            <SelectComponent
                                instanceId="related_ibge"
                                label="Projeto relacionado"
                                value={state.related_ibge}
                                name="related_ibge"
                                isDisabled={true}
                                options={options?.related_ibge ?? []}
                            />
                        </div>

                        <div className="col-span-2 text-gray-900">
                            <SelectComponent
                                instanceId="type_project"
                                label="Tipo"
                                value={state.type_project}
                                name="type_project"
                                isDisabled={true}
                                options={[
                                    {value: "DC", label: "Defesa Civil"},
                                    {value: "OU", label: "Outro"},
                                    {value: "TR", label: "Trânsito"}
                                ]}
                            />
                        </div>
                    </>
                }

                <InputForm id="code" value={state.code ?? ""} label="ID *" col="col-span-2" disabled={true}/>

                <div className="col-span-2 text-gray-900">
                    <SelectComponent
                        instanceId="category"
                        label="Categoria"
                        value={state.category}
                        name="category"
                        isDisabled={true}
                        options={[
                            {value: "city_cat", label: "Cidade"},
                            {value: "state_cat", label: "Estado"},
                            {value: "others_cat", label: "Outros"}
                        ]}
                    />
                </div>

                <div className="col-span-3 text-gray-900">
                    <SelectComponent
                        instanceId="department"
                        label="Departamento"
                        value={state.department}
                        name="department"
                        isDisabled={true}
                        options={[
                            {value: "security_dep", label: "Secretaria de Segurança"},
                            {value: "transit_dep", label: "Secretaria de Trânsito"},
                            {value: "others_dep", label: "Outros"}
                        ]}
                    />
                </div>

                <div className="flex gap-4 col-span-7">
                    <InputForm id="observation" name="observation" label="Observação" col="w-full" value={state.observation} disabled={true}/>

                    <InputCheckbox id="resale_only" name="resale_only" label="Atendimento apenas pela revenda" col={"w-[350px]"}
                                   disabled={true}
                                   checked={state.resale_only} />
                </div>

                <InputText id="info" name="info" value={state.info ?? ""} readOnly={true} label="Rede e acessos" col="col-span-6"/>

                <InputText id="ssh_warning" name="ssh_warning" value={state.ssh_warning ?? ""} readOnly={true} label="Avisos" col="col-span-6"/>
            </div>

            <span style={{ whiteSpace: 'nowrap', marginRight: '1rem' }} className="text-lg">Licenças</span>
            <div style={{ flex: 1, borderBottom: '1px solid #ccc' }}></div>
            {hasLicensesHistoryPermission && (
                <>
                    <div className={"mt-4"}>
                        <Button target="primary" onClick={() => setLicenseHistoryOpen(true)}>
                            <FaHistory/>
                            Histórico
                        </Button>
                    </div>

                </>
            )}
            <div className={"ag-theme-quartz grid mt-5 mb-5"}>
                <AgGridReact
                    ref={licencesRef}
                    rowHeight={32}
                    rowData={[pinnedBottomValues]}
                    columnDefs={licensesColumnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={false}
                    suppressRowClickSelection={true}
                    gridOptions={{localeText: LocalizationAgGrid}}
                    domLayout='autoHeight'
                    suppressCellFocus={true}
                    context={{ readOnlyTable }}
                />
            </div>

            <span style={{ whiteSpace: 'nowrap', marginRight: '1rem' }} className="text-lg">Contatos</span>
            <div style={{ flex: 1, borderBottom: '1px solid #ccc' }}></div>
            <ContactsTable contacts={state.contacts} gridRef={contactsRef} wrapperClass={"mt-5 mb-5"} resume={true} readOnlyTable/>

            <span style={{ whiteSpace: 'nowrap', marginRight: '1rem' }} className="text-lg">SSH</span>
            <div style={{ flex: 1, borderBottom: '1px solid #ccc' }}></div>
            <SshTable data={state.project_ssh} gridRef={sshRef} wrapperClass={"mt-5 mb-5"} resume={true}  readOnlyTable/>

            <span style={{ whiteSpace: 'nowrap', marginRight: '1rem' }} className="text-lg">Equipamentos</span>
            <div style={{ flex: 1, borderBottom: '1px solid #ccc' }}></div>

            <EquipmentTable equipment={state.equipment} gridRef={equipmentRef} wrapperClass={"mb-5"} resume={true} readOnlyTable/>

            <span style={{ whiteSpace: 'nowrap', marginRight: '1rem' }} className="text-lg">Outras informações</span>
            <div style={{ flex: 1, borderBottom: '1px solid #ccc' }}></div>

            <InputText textarearef={resumeLinkRef} fontFamily={"font-consolas"} id="multiway_link" name="multiway_link" value={state.multiway_link ?? ""} disabled={true} label="Link da Multiway" col="col-span-2 mt-6"/>

            <InputText textarearef={resumeObservationRef} fontFamily={"font-consolas"} id="install_observation" name="install_observation" value={state.install_observation ?? ""} disabled={true} label="Observação" col="col-span-2 mt-6"/>

            {hasLicensesHistoryPermission && (
                <LicenseHistoryModal
                    isOpen={licenseHistoryOpen}
                    onClose={() => setLicenseHistoryOpen(false)}
                    code={state.code}
                />
            )}
        </Card>
    );
};

export default ResumeCard;
